exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HeaderStatistic__button___1jJno {\n\ttext-align: center;\n\tfont-size: 0.65rem;\n    margin-left: 0.25rem;\n    border: 0;\n    background: transparent;\n}\n.HeaderStatistic__button___1jJno:focus { outline: 0; }\n\n.HeaderStatistic__button___1jJno:active {\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;\n}\n\n.HeaderStatistic__count___3ZNzG {\n\tfont-size: 0.85rem;\n\tfont-weight: 600;\n\tline-height: 0.95rem;\n}\n\n.HeaderStatistic__name___p29iL {\n\tletter-spacing: -0.05px;\n}\n\n.HeaderStatistic__link___1UaTm {\n\tdisplay: inline-block;\n}\n", ""]);

// exports
exports.locals = {
	"button": "HeaderStatistic__button___1jJno",
	"count": "HeaderStatistic__count___3ZNzG",
	"name": "HeaderStatistic__name___p29iL",
	"link": "HeaderStatistic__link___1UaTm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/HeaderStatistic.icss
// module id = 1269
// module chunks = 0